import Swiper from "swiper";
import {Autoplay} from 'swiper/modules';

// swiper carousel
export const swiperIntro = () => {
	return document.querySelector(".swiper-intro") ? new Swiper(".swiper-intro", {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		autoplay: {
			delay: 3000,
		},	
        modules: [Autoplay], 
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 0,
				loop: false,
			},
		},
	}) : false;
}









export const swiperSimpleCarousel = () => {
	return document.querySelector(".swiper-simplecarousel") ? new Swiper(".swiper-simplecarousel", {
		slidesPerView: "auto",
      centeredSlides: true,
		spaceBetween: 30,
		modules: [Navigation, Pagination], 	
		navigation: {
			nextEl: ".swiper-simplecarousel-button-next",
			prevEl: ".swiper-simplecarousel-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		
	}) : false;
}

